export const CONTACT_TYPE_SELECTED = 'waitrose/cms-page/contact-us';
